import { Outlet } from 'react-router-dom';

import { ADMIN_PATH } from '@/features/admin';
import { AdminMainLayout } from '@/features/admin/AdminMainLayout';
import { GuardAuthenticated } from '@/features/auth';
import { UserType } from '@/services/api';

export function AdminATSAuthenticatedLayout() {
  return (
    <GuardAuthenticated
      authorizations={[UserType.CompanyAdmin, UserType.SharedInterview]}
      loginPath={`${ADMIN_PATH}/login`}
    >
      <AdminMainLayout>
        <Outlet />
      </AdminMainLayout>
    </GuardAuthenticated>
  );
}
